exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-shared-Checkbox-checkbox{cursor:pointer;color:#929292;margin:5px;color:#fff}.src-components-shared-Checkbox-checkbox span:before{font-family:\"FontAwesome\";content:\"\\F0C8\";text-shadow:-1px 0 gray,0 1px gray,1px 0 gray,0 -1px gray}.src-components-shared-Checkbox-checked{color:#15284b}.src-components-shared-Checkbox-checked span:before{content:\"\\F14A\";text-shadow:none}.src-components-shared-Checkbox-disabled{cursor:default;color:#929292}", ""]);

// exports
exports.locals = {
	"checkbox": "src-components-shared-Checkbox-checkbox",
	"checked": "src-components-shared-Checkbox-checked",
	"disabled": "src-components-shared-Checkbox-disabled"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/Checkbox/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/Checkbox/styles.scss
// module chunks = 1